import { Badge } from '@components/badge';
import { IconPerson } from '@components/icons/person';
import { abbreviateDate } from '@utils/date';

import { TravellerJourneyListItem } from 'api/types';

import { statusTagMap, statusLabelMap } from '../constants';
import { useTravellerJourneyListTranslate } from '../locale';

export const StatusCell = ({ row: traveller }: { row: TravellerJourneyListItem }) => {
  const { t } = useTravellerJourneyListTranslate();
  const { manualCompletion } = traveller;
  if (!manualCompletion) {
    return (
      <Badge variant={statusTagMap[traveller.status]} text={statusLabelMap[traveller.status]} />
    );
  }
  return (
    <Badge
      variant="green"
      icon={<IconPerson />}
      text={statusLabelMap.completed}
      tooltip={{
        header: t('markedAsCompletedBy', { name: manualCompletion.performedByName }),
        content: [
          abbreviateDate(manualCompletion.dateCreated, 'en', 'datetime'),
          manualCompletion.reason || t('noReasonGiven'),
        ].join('\n'),
      }}
    />
  );
};
